export const TryItColumns = [
    { field: 'level-1', headerName: 'Level-1', width: 180, editable: true, sortable: false },
    { field: 'level-2', headerName: 'Level-2', width: 180, editable: true, sortable: false },
    { field: 'level-3', headerName: 'Level-3', width: 180, editable: true, sortable: false },
    { field: 'level-4', headerName: 'Level-4', width: 180, editable: true, sortable: false },
    { field: 'level-5', headerName: 'Level-5', width: 180, editable: true, sortable: false },
    { field: 'level-6', headerName: 'Level-6', width: 180, editable: true, sortable: false },
    { field: 'level-7', headerName: 'Level-7', width: 180, editable: true, sortable: false },
];
  
export const TryItRows = [
    {
        id: 1,
        'level-1': "",
        'level-2': "",
        'level-3': "",
        'level-4': "",
        'level-5': "",
        'level-6': "",
        'level-7': "",
    },
    {
        id: 2,
        'level-1': "",
        'level-2': "",
        'level-3': "",
        'level-4': "",
        'level-5': "",
        'level-6': "",
        'level-7': "",
    },
    {
        id: 3,
        'level-1': "",
        'level-2': "",
        'level-3': "",
        'level-4': "",
        'level-5': "",
        'level-6': "",
        'level-7': "",
    },
    {
        id: 4,
        'level-1': "",
        'level-2': "",
        'level-3': "",
        'level-4': "",
        'level-5': "",
        'level-6': "",
        'level-7': "",
    },
    {
        id: 5,
        'level-1': "",
        'level-2': "",
        'level-3': "",
        'level-4': "",
        'level-5': "",
        'level-6': "",
        'level-7': "",
    },
    {
        id: 6,
        'level-1': "",
        'level-2': "",
        'level-3': "",
        'level-4': "",
        'level-5': "",
        'level-6': "",
        'level-7': "",
    },
    {
        id: 7,
        'level-1': "",
        'level-2': "",
        'level-3': "",
        'level-4': "",
        'level-5': "",
        'level-6': "",
        'level-7': "",
    },
    {
        id: 8,
        'level-1': "",
        'level-2': "",
        'level-3': "",
        'level-4': "",
        'level-5': "",
        'level-6': "",
        'level-7': "",
    },
    {
        id: 9,
        'level-1': "",
        'level-2': "",
        'level-3': "",
        'level-4': "",
        'level-5': "",
        'level-6': "",
        'level-7': "",
    },
    {
        id: 10,
        'level-1': "",
        'level-2': "",
        'level-3': "",
        'level-4': "",
        'level-5': "",
        'level-6': "",
        'level-7': "",
    },
   
];
